import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { provideApiBaseUrl } from '@rekruto/core';

import { providePortalCompany } from './core/portal-company.token';
import { routes } from './app.routes';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      // The apply confirmation and the round sends navigate within one screen's state; restore
      // the browser scroll position, jump to top on fresh navigations.
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
    ),
    provideHttpClient(withXhr()),
    provideApiBaseUrl(environment.apiUrl),
    providePortalCompany(environment.companySlug),
  ],
};
